import React from "react";
import styles from "../styles.module.scss";
import { useTranslation } from "react-i18next";

const ReportPagination = ({loading, pageNumber, maxPageNumber, setPageNumber, noPerPage, setNoPerPage}) => {
    const { t } = useTranslation();

    if (loading) {
        return null;
    }

    const handleInputChange = (value) => {
        if (value >= 1 && value <= maxPageNumber) {
            setPageNumber(value);
        }
    };

    const options = [
        {
          label: '20',
          value: 20,
        },
        {
          label: '40',
          value: 40,
        },
        {
          label: '60',
          value: 60,
        },
    ];

    return (
        <div className={styles.pagination_container}>
            <div className={styles.button_container}>
                <div
                    className={styles.arrow_container}
                    onClick={() => handleInputChange(pageNumber - 1)}
                >
                    <i className={`ico ico-chevron ${styles.left_arrow}`} />
                </div>
                <div className={styles.input_container}>
                    <input
                        type="number"
                        value={pageNumber}
                        onChange={handleInputChange}
                        className={styles.number_input}
                    />
                    <p>{t('of ')}</p>
                    <p>{maxPageNumber}</p>
                </div>
                <div
                    className={styles.arrow_container}
                    onClick={() => handleInputChange(pageNumber + 1)}
                >
                    <i className={`ico ico-chevron ${styles.right_arrow}`} />
                </div>
            </div>
            <div className={styles.button_container}>
                <div className={styles.select_container}>
                    <select
                        value={noPerPage}
                        className={styles.number_of_elements_select}
                        onChange={(event) => setNoPerPage(event.target.value)}
                    >
                        {options.map((option) => (
                            <option
                                key={option.value}
                                value={option.value}
                            >
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <p>{t("/ page")}</p>
                </div>
                <div className={styles.absolute_arrow_container}>
                    <i className={`ico ico-chevron ${styles.down_arrow}`} />
                </div>
            </div>
        </div>
    );
};

export default ReportPagination;
